import { Component, Input, OnInit } from '@angular/core';
import {
  PortalProductsSubscriptionsQuery,
  PortalProductsSubscriptionsService,
  CustomerProductSusbcriptionPaymentStatusType,
} from '@fgb/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ProductCode } from 'src/app/shared/utilities/product-code';

@Component({
  selector: 'fgb-upgrade-banner',
  templateUrl: './upgrade-banner.component.html',
  styleUrls: ['./upgrade-banner.component.scss'],
})
export class UpgradeBannerComponent implements OnInit {
  @Input() isHomePage: boolean = false;
  showUpgradeBanner$: Observable<boolean>;
  productCode = ProductCode;
  constructor(
    private portalProductsSubscriptionsQuery: PortalProductsSubscriptionsQuery,
    private portalProductsSubscriptionsService: PortalProductsSubscriptionsService
  ) {}

  ngOnInit() {
    this.portalProductsSubscriptionsService.fetchSubscriptions().toPromise();
    this.showUpgradeBanner$ = this.portalProductsSubscriptionsQuery.selectSubscriptionsByProductTypes([1]).pipe(
      map((products) =>
        !products.some((product) => product.SubscriptionPaymentStatus === CustomerProductSusbcriptionPaymentStatusType.Active)
      )
    );
  }
}
